import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createButtonBlock,
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getColorOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { getBlockSecondaryStyleOptions } from "../../constants";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProfessionalNetworkHomepageBlock9",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Let’s build the program only you can lead",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
        createPBlock({
          text: "You don’t need more noise—you need a system built for clarity, momentum, and purpose. Together, we’ll turn your expertise into something transformational.",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    buttons: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Enroll Now",
          href: "#",
          buttonType: "secondaryButton",
        }),
        createButtonBlock({
          text: "Schedule a call",
          href: "#",
          buttonType: "customButton",
          styles: {
            default: {
              color: getColorOptions(
                "var(--theme-website-primary-button-default-text-color)",
              ),
              backgroundColor: getBackgroundColorOptions({
                defaultValue: "transparent",
              }),
            },
          },
        }),
      ],
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Limited seats available. Applications close at month-end.",
          paragraphStyle: "p3",
          styles: {
            color: getColorOptions(
              "var(--theme-website-primary-button-default-text-color)",
            ),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockSecondaryStyleOptions(),
        backgroundColor: getBackgroundColorOptions({
          defaultValue: "var(--theme-website-color-6)",
        }),
      },
    },
  },
};
